import React from 'react';
import {Button, Popconfirm, Space} from "antd";
import {ArrowDownOutlined, ArrowUpOutlined, DeleteOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import IntlMessage from "../../../../../components/IntlMessage/IntlMessage";

/**
 * Кнопки строки динамического списка: выше, ниже, удалить.
 *
 * Отдельный компонент, а не разметка внутри fields.map: подписи кнопок нужны строкой
 * (атрибут title), а строка берётся из useTranslation — хук нельзя звать в теле .map
 * родителя. Внутри собственного компонента это обычный хук верхнего уровня.
 */
const ListRowActions = ({index, total, onMove, onRemove}) => {
    const {t} = useTranslation();

    return (
        <Space size={4}>
            <Button
                type={"text"}
                size={"small"}
                icon={<ArrowUpOutlined/>}
                title={t('marketCoursesPage.moveUp')}
                disabled={index === 0}
                onClick={() => onMove(index, index - 1)}
            />
            <Button
                type={"text"}
                size={"small"}
                icon={<ArrowDownOutlined/>}
                title={t('marketCoursesPage.moveDown')}
                disabled={index === total - 1}
                onClick={() => onMove(index, index + 1)}
            />
            <Popconfirm
                title={<IntlMessage id={'marketCoursesPage.removeRowConfirm'}/>}
                okText={<IntlMessage id={'delete'}/>}
                cancelText={<IntlMessage id={'cancel'}/>}
                okButtonProps={{danger: true}}
                onConfirm={() => onRemove(index)}
            >
                <Button
                    type={"text"}
                    size={"small"}
                    danger
                    icon={<DeleteOutlined/>}
                    title={t('marketCoursesPage.removeRow')}
                />
            </Popconfirm>
        </Space>
    );
};

export default ListRowActions;
